var map = {
	"./Group.png": 88966,
	"./Vector.svg": 41216,
	"./add-column-button.svg": 77660,
	"./add-task-button.svg": 51470,
	"./add-tast-button.svg": 49673,
	"./addChecklist.svg": 67586,
	"./amail.svg": 8169,
	"./arrow-toggle-down.svg": 1542,
	"./artı.svg": 76425,
	"./assignee.svg": 22525,
	"./attach.svg": 61117,
	"./attachment.svg": 14689,
	"./attechments.svg": 11192,
	"./backlog_button.svg": 26305,
	"./calendar.svg": 90874,
	"./checklist.svg": 71038,
	"./copkutusu.svg": 32315,
	"./create-button.png": 43073,
	"./create-new-button.svg": 50703,
	"./createNew.svg": 95051,
	"./deadline.svg": 31380,
	"./delete.svg": 82539,
	"./depolama.svg": 80827,
	"./description.svg": 46747,
	"./etiket.svg": 71554,
	"./flag.svg": 29866,
	"./icons8-linkedin.svg": 86352,
	"./info.svg": 67292,
	"./join.svg": 43113,
	"./kalem.svg": 35075,
	"./logo_yartu.png": 89754,
	"./matkComplate.svg": 78159,
	"./newChecklist.svg": 66106,
	"./noDeadline.svg": 86771,
	"./not.svg": 33156,
	"./office.svg": 91250,
	"./palette.svg": 72196,
	"./person.svg": 40340,
	"./proje.svg": 38974,
	"./rehber.svg": 67833,
	"./save_button.png": 86104,
	"./twitter.svg": 83961,
	"./unarchive.svg": 43131,
	"./videoKonferans.svg": 98159,
	"./yuvarlakCarp.svg": 57360,
	"./yıldız.svg": 2424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;